<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
    >
      <!-- <abc :abcvalue="myvalue" @ondo="ondoHandler" ref="abc"></abc> -->

      <!-- {{ this.myvalue }} -->

      <agentVendorShop @select="selectHandler" />

      <div>
        <el-form-item label="机器ID">
          <el-input
            v-model="formInline.machineid"
            placeholder="请输入机器ID"
          ></el-input>
        </el-form-item>

        <el-form-item label="IMEI">
          <el-input
            v-model="formInline.machineImei"
            placeholder="请输入机器IMEI"
          ></el-input>
        </el-form-item>

        <el-form-item label="机器类型">
          <el-select
            v-model="formInline.machineType"
            placeholder="请选择"
            @change="handleChangeMachineType"
          >
            <el-option label="全部" :value="''"></el-option>

            <el-option
              v-for="(item, index) in $AllMachineModelInfoList"
              :key="index"
              :label="item.machineTypeCnName"
              :value="item.machineTypeCode"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="机器型号">
          <el-select v-model="formInline.machineModel" placeholder="请选择">
            <el-option label="全部" :value="''"></el-option>

            <template v-if="formInline.machineType">
              <el-option
                v-for="(item, index) in $AllMachineModelInfoList.find(
                  ele => ele.machineTypeCode === formInline.machineType
                ).machineSpec"
                :key="index"
                :label="item.machineModel + '【' + item.machineModelName + '】'"
                :value="item.machineModel"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
      </div>

      <el-form-item label="机器状态">
        <el-select v-model="formInline.machineStatus" placeholder="请选择">
          <el-option
            v-for="(item, index) in MACHINE_STATUS_ENUM"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否可用">
        <el-select v-model="formInline.machineEnable" placeholder="请选择">
          <el-option
            v-for="(item, index) in machineEnableList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机器维护人员">
        <el-input
          v-model="formInline.machineOperator"
          placeholder="请输入机器维护人员"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-form>
      <el-form-item style="margin-left:1.5rem;">
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
        <el-button type="primary" icon="el-icon-plus" @click="onAdd"
          >新增</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-delete"
          @click="onBatchDelete"
          :disabled="multipleSelection.length === 0"
          >批量删除</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="handlePrint"
          :disabled="multipleSelection.length === 0"
          >查看二维码</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="handleZhifubaoQRCode"
          :disabled="multipleSelection.length === 0"
          >支付宝二维码</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="handleNormalQRCode"
          :disabled="multipleSelection.length === 0"
          >通用二维码</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        prop="machineid"
        label="机器id"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="machineImei"
        label="IMEI"
        width="150"
      ></el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          {{ scope.row.machineTypeCnName }}
        </template>
      </el-table-column>
      <el-table-column prop="machineModel" label="型号"></el-table-column>
      <el-table-column prop="machineName" label="名称"></el-table-column>
      <el-table-column label="加盟商">
        <template slot-scope="scope">
          <div>
            {{ $getVendorName(scope.row.vendorid) }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="machineCity" label="城市"></el-table-column> -->
      <el-table-column label="所属门店">
        <template slot-scope="scope">
          <div>
            {{ $getShopName(scope.row.machineInShopid) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="序列号">
        <template slot-scope="scope">
          <div>
            {{ scope.row.machineSn }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="machineCodeInShop"
        label="店内编号"
      ></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag
            type="info"
            effect="dark"
            v-if="scope.row.machineStatus == -1"
          >
            离线</el-tag
          >

          <el-tag
            type="warning"
            effect="dark"
            v-else-if="scope.row.machineStatus == 0"
            >门未关</el-tag
          >

          <el-tag
            type="success"
            effect="dark"
            v-else-if="scope.row.machineStatus == 2"
            >待机</el-tag
          >

          <el-tag type effect="dark" v-else-if="scope.row.machineStatus == 8"
            >启动</el-tag
          >

          <el-tag
            type="success"
            effect="dark"
            v-else-if="scope.row.machineStatus == 16"
            >运行中</el-tag
          >

          <el-tag
            type="success"
            effect="dark"
            v-else-if="scope.row.machineStatus == 32"
            >运行结束</el-tag
          >

          <el-tag
            type="danger"
            effect="dark"
            v-else-if="scope.row.machineStatus == 64"
            >故障</el-tag
          >

          <el-tag
            type="danger"
            effect="dark"
            v-else-if="scope.row.machineStatus == 128"
            >菜单</el-tag
          >
          <el-tag
            type="danger"
            effect="dark"
            v-else-if="scope.row.machineStatus == 1006"
            >进水超时</el-tag
          >
          <el-tag
            type="danger"
            effect="dark"
            v-else-if="scope.row.machineStatus == 1007"
            >排水超时</el-tag
          >
          <el-tag
            type="danger"
            effect="dark"
            v-else-if="scope.row.machineStatus == 1008"
            >脱水时撞桶</el-tag
          >
          <el-tag
            type="danger"
            effect="dark"
            v-else-if="scope.row.machineStatus == 1009"
            >脱水开盖</el-tag
          >

          <el-tag
            type="danger"
            effect="dark"
            v-else-if="scope.row.machineStatus == 1010"
            >水位传感器异常</el-tag
          >
          <el-tag
            type="danger"
            effect="dark"
            v-else-if="scope.row.machineStatus == 1011"
            >溢水报警</el-tag
          >
          <el-tag
            type="danger"
            effect="dark"
            v-else-if="scope.row.machineStatus == 1012"
            >电机故障</el-tag
          >

          <el-tag type="danger" effect="dark" v-else
            >未知{{ scope.row.machineStatus }}</el-tag
          >
        </template>
      </el-table-column>

      <el-table-column label="工作时间">
        <template slot-scope="scope">
          <div>
            {{ scope.row.machineStartTime }}-{{ scope.row.machineStopTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="剩余时间">
        <template slot-scope="scope">
          <div>
            {{ Math.floor(scope.row.machineLeftTime / 60) }}分{{
              scope.row.machineLeftTime % 60
            }}秒
          </div>
        </template>
      </el-table-column>
      <el-table-column label="备注">
        <template slot-scope="scope">
          <div>
            {{ scope.row.remark }}
          </div>

          <!-- <div>{{ scope.row.machineInShopid }}</div> -->
        </template>
      </el-table-column>
      <el-table-column label="可用" width="60">
        <template slot-scope="scope">
          <i
            class="el-icon-check"
            style="color:#67c23a;font-weight:bold;"
            v-if="scope.row.machineEnable"
          ></i>

          <i
            class="el-icon-close"
            style="color:#e66100;font-weight:bold;"
            v-else
          ></i>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDelete(scope.row.machineid)">
            删除</el-button
          >

          <el-button type="text" @click="handleEdit(scope.row)">详情</el-button>

          <el-button type="text" @click="handleControl(scope.row)"
            >控制</el-button
          >

          <el-button type="text" @click="handleRedirct(scope.row.machineid)"
            >订单</el-button
          >

          <el-button
            type="text"
            @click="directToNotifyMessage(scope.row.machineid)"
            >报文</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
    <CreateDialog
      v-if="isCreated"
      @closeForm="closeForm"
      @handleUpdate="onSubmit"
    />
    <EditDialog
      v-if="isEdit"
      :machineInfo="machineInfo"
      @closeForm="closeForm"
      @handleUpdate="onSubmit"
    />
    <Printer
      v-if="isPrint"
      :imageIDs="imageIDs"
      @closeForm="closeForm"
      @handleUpdate="onSubmit"
    />
    <ZhifubaoQRCode
      v-if="isShowHandleZhifubaoQRCode"
      :imageUrl="zhifubaoQRCodeUrl"
      :machineid="imageIDs[0]"
      @closeForm="closeForm"
    />
    <NormalQRCode
      v-if="isShowHandleNormalQRCode"
      :machineids="imageIDs"
      @closeForm="closeForm"
    />
    <ControlDialog
      v-if="isControl"
      :machineInfo="machineInfo"
      @closeForm="closeForm"
      @handleUpdate="onSubmit"
      @refreshMachine="refreshMachine"
    />
  </div>
</template>

<script>
// import abc from "@/components/layout/abc";
import agentVendorShop from "@/components/layout/agentVendorShop";

import enumObject from "../../plugins/enum";
import CreateDialog from "./components/createDialog";
import Printer from "./components/printer";
import ZhifubaoQRCode from "./components/zhifubaoQRCode";
import NormalQRCode from "./components/normalQRCode";

import EditDialog from "./components/editDialog";
import ControlDialog from "./components/controlDialog";
//import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    // abc,
    agentVendorShop,
    CreateDialog,
    EditDialog,
    ControlDialog,
    Printer,
    ZhifubaoQRCode,
    NormalQRCode
  },
  data() {
    return {
      myvalue: 1,
      formInline: {
        machineid: "",
        machineImei: "",
        machineType: "",
        machineModel: "",
        machineManufactureDate: "",
        machineName: "",
        agentid: "",
        vendorid: "",
        machineCity: "",
        machineInShopid: "",
        machineCodeInShop: "",
        machineStatus: "",
        machineEnable: "",
        machineOperator: ""
      },
      tableData: [],
      CITY_ENUM: enumObject.CITY_ENUM,
      MACHINE_STATUS_ENUM: enumObject.MACHINE_STATUS_ENUM,
      //vendorsList: [],
      machineEnableList: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "是",
          value: true
        },
        {
          label: "否",
          value: false
        }
      ],
      multipleSelection: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      isCreated: false,
      isEdit: false,
      isPrint: false,
      isControl: false,
      isShowHandleZhifubaoQRCode: false,
      zhifubaoQRCodeUrl: null,
      isShowHandleNormalQRCode: false,

      machineInfo: null,
      imageIDs: [],
      // shopInfoEntityList: [],
      // vendorEntityList: [],
      machineModelList: [],
      //vendorList: [],
      //shopList: [],
      //agentList: []
      agentListForPrompt: [],
      vendorListForPrompt: [],
      shopListForPrompt: []
    };
  },

  async mounted() {
    console.log(this.$AllMachineModelInfoList);

    if (this.$route.query.shopid) {
      //await this.getShops({ shopid: this.$route.query.shopid });
      this.formInline.machineInShopid = this.$route.query.shopid;
    }
    if (this.$route.query.machineEnable != undefined) {
      this.formInline.machineEnable = this.$route.query.machineEnable;
    }
    if (this.$route.query.machineid) {
      this.formInline.machineid = this.$route.query.machineid;
    }
    if (this.$route.query.imei) {
      this.formInline.machineImei = this.$route.query.imei;
    }
    if (this.$route.query.machineStatus != undefined) {
      this.formInline.machineStatus = this.$route.query.machineStatus;
    }

    this.onSubmit();
  },

  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.formInline.agentid = x.selectedAgent.agentid;
      this.formInline.vendorid = x.selectedVendor.vendorid;
      this.formInline.machineInShopid = x.selectedShop.shopid;
    },
    onSubmit() {
      let queryModel = {
        machineid: this.formInline.machineid,
        machineImei: this.formInline.machineImei,
        machineType: this.formInline.machineType,
        machineModel: this.formInline.machineModel,
        machineManufactureDateFrom: Array.isArray(
          this.formInline.machineManufactureDate
        )
          ? this.$ToDateString(this.formInline.machineManufactureDate[0])
          : null,
        machineManufactureDateTo: Array.isArray(
          this.formInline.machineManufactureDate
        )
          ? this.$ToDateString(this.formInline.machineManufactureDate[1])
          : null,
        machineName: this.formInline.machineName,
        vendorid: this.formInline.vendorid,
        agentid: this.formInline.agentid,
        machineCity: this.formInline.machineCity,
        machineInShopid: this.formInline.machineInShopid,
        machineCodeInShop: this.formInline.machineCodeInShop,
        machineStatus: this.formInline.machineStatus,
        machineEnable: this.formInline.machineEnable,
        machineOperator: this.formInline.machineOperator,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      if (this.formInline.machineModel == "全部") {
        queryModel.machineModel = null;
      }
      this.$axios(this.$urlMapping["查询机器"], {
        data: queryModel
      }).then(result => {
        this.tableData = result.data.map(ele => ele.machineExtendModel);
        this.shopInfoEntityList = result.data
          .map(ele => ele.shopInfoEntity)
          .filter(ele => ele !== null);
        this.vendorEntityList = result.data
          .map(ele => ele.vendorEntity)
          .filter(ele => ele !== null);
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    onAdd() {
      this.isCreated = true;
    },
    onBatchDelete() {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let machineids = this.multipleSelection.map(ele => ele.machineid);
        this.$axios(this.$urlMapping["删除机器"], {
          data: {
            machineids
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },

    directToNotifyMessage(machineid) {
      this.$router.push({
        name: "notifyMessage",
        query: {
          machineid: machineid,
          from: this.$ToDateTimeString(moment().subtract(30, "minute")),
          to: this.$ToDateTimeString(moment())
        }
      });
    },
    handleRedirct(machineid) {
      console.log(machineid);
      this.$router.push({
        name: "order",
        query: {
          machineid: machineid
        }
      });
    },

    async handleCreateZhifubaoQrcode(machineid) {
      await this.createZhifubaoQrcode(machineid);
    },

    createZhifubaoQrcode(machineid) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["生成支付宝二维码"], {
          data: {
            machineid
          }
        }).then(result => {
          console.log(result);
          this.zhifubaoQRCodeUrl = result.qrCodeUrl;
          resolve();
        });
      });
    },

    handleNormalQRCode() {
      this.imageIDs = this.multipleSelection.map(ele => ele.machineid);
      this.isShowHandleNormalQRCode = true;
    },

    // handleChangeAgent() {
    //   this.formInline.vendorid = this.formInline.machineInShopid = "";
    //   this.vendorList = [];
    //   this.shopList = [];
    //   if (this.formInline.agentid != "") {
    //     this.queryVendor({ agentid: this.formInline.agentid });
    //   }
    // },
    // handleChangeVendor() {
    //   if (this.formInline.vendorid == "") {
    //     this.shopList = [];
    //     this.formInline.machineInShopid = "";
    //   } else {
    //     this.$axios(this.$urlMapping["查询门店"], {
    //       data: {
    //         shopOwner: this.formInline.vendorid
    //       }
    //     }).then(result => {
    //       let shopInfoEntityList = result.data.map(ele => ele.shopInfoEntity);
    //       this.shopList = [
    //         { shopid: "", shopName: "全部" },
    //         ...shopInfoEntityList
    //       ];
    //       this.formInline.machineInShopid = "";
    //     });
    //   }
    // },
    handleDelete(machineid) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let machineids = [machineid];
        this.$axios(this.$urlMapping["删除机器"], {
          data: {
            machineids
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },
    handleEdit(machineInfo) {
      console.log("handleEdit");
      console.log(machineInfo);
      this.machineInfo = machineInfo;
      this.isEdit = true;
    },
    handlePrint() {
      this.isPrint = true;
      this.imageIDs = this.multipleSelection.map(ele => ele.machineid);
    },

    async handleZhifubaoQRCode() {
      this.imageIDs = this.multipleSelection.map(ele => ele.machineid);
      if (this.imageIDs != null && this.imageIDs.length > 1) {
        this.$notify.error({
          title: "错误",
          message: "仅只能选1个机器"
        });
        return;
      }
      await this.handleCreateZhifubaoQrcode(this.imageIDs[0]);

      this.isShowHandleZhifubaoQRCode = true;
    },

    handleControl(machineInfo) {
      this.machineInfo = machineInfo;
      this.isControl = true;
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    closeForm() {
      this.isCreated = false;
      this.isEdit = false;
      this.isControl = false;
      this.isPrint = false;
      this.isShowHandleZhifubaoQRCode = false;
      this.isShowHandleNormalQRCode = false;
    },

    setColor(code) {
      switch (code) {
        case 0:
          return {
            color: "#909399"
          };
        case 2:
          return {
            color: "#409EFF"
          };
        case 8:
          return {
            color: "#E6A23C"
          };
        case 16:
          return {
            color: "#67C23A"
          };
        case 32:
          return {
            color: "#F56C6C"
          };
        default:
          return {
            color: "#000000"
          };
      }
    },
    refreshMachine(machineInfo) {
      this.machineInfo = machineInfo;
    },
    handleChangeMachineType() {
      this.formInline.machineModel = "";
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 202px;
}
</style>
